<template>
	<div class="content">
		<!--头部-->
		<XDheader></XDheader>
		<div class="container">
			<img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/banner.png" alt />
			<h5>当前位置/{{menuname?menuname:info.tags[0]?info.tags[0]:this.$route.params.func}}</h5>
			<!--内容-->
			<div class="row">
				<!-- 点击新闻列表进入 -->
				<div class="cc col-md-8">
					<div class="content_title">
						<span class="themes_menu_wrap_1">{{menuname?menuname:info.tags[0]?info.tags[0]:this.$route.params.func}}</span>
					</div>
					<h6 class="title" style="margin-top:50px;">{{info.title}}</h6>
					<div v-html="newsinfo"></div>
				</div>
				<div class="col-md-4">
					<XDright></XDright>
				</div>
			</div>
		</div>
		<!--底部-->
		<XDfooter></XDfooter>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	name: "Content",
	data() {
		return {
			newsinfo: "",
			info: {},
			tags: ""
		};
	},
	created() {
		this.getcontent();
	},
	watch: {
		$route: "getcontent"
	},
	methods: {
		getcontent() {
			// console.log(111, this.$route.params);
			if (this.$route.params.uuid) {
				const { gameId, uuid } = this.$route.params;
				api.getcontent({ gameId, uuid }).then(({ data }) => {
					// console.log(data);
					if (data.code == 0) {
						if (data.data) {
							this.info = data.data;
							this.newsinfo = data.data.content;
						} else {
							this.info = { tags: [] };
							this.newsinfo = this.emptycontent;
						}
					} else {
						this.$message.error(data.msg);
					}
				});
			}
			if (this.$route.params.func) {
				const { gameId, func } = this.$route.params;
				api.getcontentByFunc({ gameId, func }).then(({ data }) => {
					// console.log(data);
					if (data.code === 0) {
						if (data.data) {
							this.info = data.data;
							this.newsinfo = data.data.content;
						} else {
							this.info = { tags: [] };
							this.newsinfo = this.emptycontent;
						}
					} else {
						console.log("没有内容");
						this.info = { tags: [] };
						this.newsinfo = this.emptycontent;
					}
				});
			}
		}
	},
	computed: {
		...mapState(["emptycontent", "menuname"])
	}
};
</script>
<style >
html,
body,
#app {
	height: 100vh;
}
.container {
	flex-grow: 2;
	padding: 0;
}
.content {
	width: 100%;
	/* min-height: 100vh; */
	display: flex;
	flex-direction: column;
}
.cc {
	height: 100%;
	text-indent: 2em;
}
img {
	width: 100%;
	padding-left: 0;
	margin-left: 0;
	/* margin-left: 20px; */
}
.no_content {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	text-align: center;
}
.no_content_wrap img {
	width: 300px;
}
h5 {
	color: #999;
	margin: 10px auto 30px;
}
.title {
	text-align: center;
	font-size: 26px;
}
/* 下侧标题*/
.content_title {
	text-indent: 0;
	background-color: #ebebeb;
	height: 60px;
	padding: 0;
}
.content_title span {
	line-height: 60px;
	display: inline-block;
	height: 100%;
	box-shadow: none;
	padding: 0 30px;
}
p img{
	margin-left: -25px;
}
p img:nth-of-type(n+2){
	margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/template/pageContent/content.vue